import styled from '@emotion/styled'

export const TrustpilotRatingWrapper = styled.div`
  width: 100%;

  /* Very messed up behaviour in Chromium where it's thinking it knows best about the color-scheme of a cross-origin iframe.
  Lumen sets ':root { color-scheme: light dark }', so with a dark device theme the app
  color-scheme is dark while the Trustpilot document is always light (data-theme="light").
  Chromium QUIETLY replaces any transparent backgrounds with black (dark theme appropriate) background,
  so Billy's inverting theme reverses dark yet again.
  Keeping it light on the widget level resolves the issue */
  iframe {
    color-scheme: light;
  }
`
